<template>
	<div class="member-schedule">
		<MSHeader v-bind:member="member" v-bind:date="date"
			@show-edit-member-self="onShowEditMemberSelf"
		/>
		<div class="ms-body" v-bind:style="styleBody">
			<div class="">
				<div class="d-flex">
					<MSScheduleList
						v-bind:items="showList"
						v-bind:isEditable="this.$store.getters.isEditable"
						v-on:progress-rate-setting="onProgressRateSetting"
					/>
				</div>
			</div>
		</div>
		<GBBottomPaneProgressRateSetting
			fetch="fetch_for_member"
			v-bind:value="bottom_sheet.progress_rate"
			v-on:close="onCloseBottomSheet"
		/>
		<GBRightPaneMemberInfo
			v-bind:value="right_pane.member_info"
			v-bind:selected_class="right_pane.class_selected"
			v-on:close="onCloseRightPane"
			v-on:show-class-select="onClickShowClassSelect"
			v-on:update-dataset="updateDataSet"
		/>
		<GBRightPaneClassSelect
			v-bind:value="right_pane.class_select"
			v-on:class-selected="onClickClassSelected"
			v-on:close="onCloseRightPane"
			v-on:update-dataset="updateDataSet"
		/>
	</div>
</template>
<script>
import clonedeep from 'lodash/cloneDeep';
import MSHeader from './MSHeader';
import MSScheduleList from './MSScheduleList';
import GBBottomPaneProgressRateSetting from './GBBottomPaneProgressRateSetting';
import GBRightPaneMemberInfo from './GBRightPaneMemberInfo';
import GBRightPaneClassSelect from './GBRightPaneClassSelect';
import Notification from '../classes/Notification';
import DataSetManager from '../classes/DataSetManager';
import { PERMISSION, FORM_MODE } from '../data/Const';
import Util from '../classes/Util';

export default {
	name: "MemberSchedule",
	data (){
		return{
			date: new Date(),
			bottom_sheet: {
				progress_rate: null,
			},
			right_pane: {
				member_info:null,
				class_select: null,
				class_selected: null,
			},
		}
	},
	components: {
		MSHeader,
		MSScheduleList,
		GBBottomPaneProgressRateSetting,
		GBRightPaneMemberInfo,
		GBRightPaneClassSelect,
	},
	methods: {
		onProgressRateSetting: function(e) {
			this.bottom_sheet.progress_rate = e;
		},
		onCloseBottomSheet: function() {
			this.bottom_sheet.progress_rate = null;
		},
		onPageShow: function(e) {
			if (e.persisted)
				window.location.reload();
		},
		onWindowResize: function() {
			Util.onWindowResize(() => {
				this.$store.dispatch('setWindowSize', {
					width: window.innerWidth,
					height: window.innerHeight,
				});
			});
		},
		onShowEditMemberSelf: function() {
			let access_token = this.$store.getters.accessToken;
			if (!access_token)
				return;

			let member = this.$store.getters.mstMemberData(access_token.sub);
			if (!member)
				return;

			this.right_pane.member_info = {
				'member': clonedeep(member),
				'mode': FORM_MODE.EDIT,
			};
		},
		onClickShowClassSelect: function(e) {
			this.right_pane.class_select = {
				selected: e,
				master_classes: clonedeep(this.$store.getters.masterClass).map(c => {
					c.is_new = 0;
					return c;
				}),
			};
		},
		onClickClassSelected: function(e) {
			this.right_pane.class_selected = e;
		},
		onCloseRightPane: function() {
			if(this.right_pane.class_select){
				this.right_pane.class_select = null
				return ;
			}
			this.right_pane.class_selected = null;
			if(this.right_pane.member_info){
				this.right_pane.member_info = null
				return ;
			}
		},
		logout: function() {
			this.$store.dispatch('logout');
			this.$router.push({name: 'Login', params: { 'contractor_id': this.$route.params.contractor_id }});
		},
		updateDataSet: function() {
			const onFail = async (err) => {
				const callback = {
					401: () => {
						this.logout();
					},
				};
				Util.updateFail(this.$store, err.response, callback);
				
				let dataset_manager = this.$store.getters.datasetManager;
				let access_token = await DataSetManager.confirmAccessToken(this.$store);
				await dataset_manager.fetch_for_member(access_token)
				.then((data) => {
					this.$store.commit('createData', data);
				})
				.catch(async (e) => {
					let notification = null;
					switch(e.response.status) {
					case 400:
						notification = Notification.error('リクエストに失敗しました', 'notificationCreateData');
						break;
					case 401:
						notification = Notification.error('もう一度ログインしてください', 'notificationCreateData');
						this.logout();
						break;
					case 403:
						notification = Notification.error('権限がありません', 'notificationCreateData');
						this.logout();
						break;
					case 404:
						notification = Notification.error('契約者情報の取得に失敗しました', 'notificationCreateData');
						break;
					case 500:
						notification = Notification.error('情報の取得に失敗しました', 'notificationCreateData');
						break;
					case 504:
						notification = Notification.error('タイムアウトしました', 'notificationCreateData');
						break;
					default :
						notification = Notification.error('通信に失敗しました', 'notificationCreateData');
						break;
					}
					this.$store.commit('addNotification', notification);
				});
			};
			const onTokenFail = () => {
				this.logout();
			};
			
			let dataset_manager = this.$store.getters.datasetManager;
			dataset_manager.setAfterDataset();
			let opt = {};
			if ((this.$store.getters.accessToken.pms & PERMISSION.TYPE.ADMIN) == 0)
				opt.member_only = true;
			dataset_manager.sync(null, onFail, onTokenFail, opt);
		},
	},
	computed: {
		member: function() {
			return this.$store.getters.memberData(this.$route.params.id);
		},
		styleBody: function() {
			return {
				height: (this.$store.getters.height) + 'px',
			};
		},
		showList: function() {
			if (this.member)
				return this.member.children;
			return [];
		},
	},
	created: function() {
		window.addEventListener('pageshow' , this.onPageShow, false);
		window.addEventListener('resize', this.onWindowResize, false);

		this.onWindowResize();
	},
	beforeDestroy: function() {
		window.removeEventListener('resize', this.onWindowResize);
		window.removeEventListener('pageshow' , this.onPageShow);
	},
};
</script>
<style>
	.member-schedule {
		width: 100%;
		background-color: #ededed;
		-moz-user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;
	}

	.ms-body{
		padding-top: 60px;
	}
</style>
